var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5,31.7c0.9,0.8,2.1,1.2,3.3,1.1c1.2,0,2.4-0.6,3.1-1.6l10.6-16.9L21.1,25.2c-1,0.7-1.6,1.9-1.6,3.2C19.4,29.6,19.7,30.8,20.5,31.7L20.5,31.7z M24,8c2,0,4,0.3,5.9,0.9c2.1,0.7,4.1,1.8,5.9,3.2L33.2,14c-1.5-1-3.1-1.7-4.8-2.2C27,11.3,25.5,11.1,24,11c-4.5-0.1-8.7,1.8-11.8,5C9,19.3,7.3,23.7,7.4,28.2c0,1.5,0.2,3.1,0.6,4.5c0.4,1.5,1,2.9,1.8,4.2h28.5c0.8-1.3,1.3-2.8,1.7-4.2c0.4-1.5,0.6-3.1,0.6-4.7c0-1.5-0.2-3-0.6-4.5c-0.4-1.6-1.2-3.1-2.2-4.5l1.9-2.6c1.2,1.8,2.1,3.6,2.8,5.6c0.6,1.8,1,3.7,1,5.6c0.1,1.9-0.1,3.8-0.6,5.7c-0.4,1.7-1.1,3.4-2,4.9c-0.2,0.6-0.7,1.1-1.3,1.4c-0.5,0.2-1.1,0.3-1.7,0.2H9.9c-0.6,0-1.2-0.2-1.7-0.4c-0.5-0.3-0.9-0.7-1.2-1.2c-0.8-1.5-1.5-3.2-2-4.9c-0.5-1.7-0.7-3.5-0.7-5.3c0-2.7,0.5-5.4,1.6-7.8c1-2.4,2.4-4.6,4.2-6.4c1.8-1.8,3.9-3.3,6.2-4.3C18.8,8.6,21.4,8,24,8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.672a8ba4b3351a7d00a13af9e99c89de.svg";
export { ForwardRef as ReactComponent };